import { motion, AnimatePresence } from 'framer-motion';
import styles from './ScarcityBanner.module.css';

interface CountdownUnitProps {
  digit: string;
  label: string;
  backgroundColor?: string;
  borderColor?: string;
  digitColor?: string;
  labelColor?: string;
}

export default function CountdownUnit({ 
  digit, 
  label, 
  backgroundColor = 'transparent', 
  borderColor = '#F2F4F3', 
  digitColor = '#FFFFFF', 
  labelColor = '#FFFFFF' 
}: CountdownUnitProps) {
  return (
    <div className={styles.countdownUnit}>
      <div className={styles.digitContainer} style={{ backgroundColor: backgroundColor, border: `1px solid ${borderColor}` }}>
        <AnimatePresence mode="popLayout">
          <motion.span
            key={digit}
            initial={{ y: '100%', opacity: 0 }}
            animate={{ y: '0%', opacity: 1 }}
            exit={{ y: '-100%', opacity: 0 }}
            transition={{ type: 'spring', stiffness: 300, damping: 30, duration: 0.3 }}
            className={styles.digit}
            style={{ color: digitColor }}
          >
            {digit}
          </motion.span>
        </AnimatePresence>
      </div>
      <span className={styles.label} style={{ color: labelColor }}>{label}</span>
    </div>
  );
}
